export default __webpack_public_path__ + "static/media/11Klein.6515bfc3.jpg";